import { Box, TextField, Typography, CircularProgress } from "@mui/material";
import React from "react";
import theme from "../../../utils/theme";
import AppButton from "../../Common/AppButton";
import FileUploaderUI from "../../Common/FileUploaderUI";
import { useSelector } from "react-redux";
import { userRoles } from "../../../utils/constant";

const styles = {
  textField: {
    bgcolor: theme.palette.background.paper,
    "& .MuiInputBase-input": {
      height: 24,
      padding: "8px 12px",
    },
  },
  title: {
    background: theme.palette.background.dark,
    color: theme.palette.text.light,
    padding: 2,
    borderRadius: "8px 8px 0 0",
  },
  content: {
    borderRadius: "0 0 8px 8px",
    border: `${theme.palette.grey[300]} 1.5px solid`,
    boxShadow: 1,
    p: 2,
    pb: 5,
    minHeight: "30vh",
  },
};

const NonDimentionalRFIDetails = ({
  formik,
  rfiDetails,
  removeFile,
  addFiles,
  isFetching,
  isUpdating,
}) => {
  const { profile } = useSelector((state) => state.profile);
  return (
    <Box container>
      <Box>
        <Typography variant="h6" sx={styles.title}>
          {rfiDetails?.project_title}
        </Typography>
      </Box>
      <Box sx={styles.content}>
        {isFetching ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "30vh",
              width: "100%",
            }}
          >
            <CircularProgress size={32} />
          </Box>
        ) : (
          <>
            <FileUploaderUI
              files={formik.values.documents}
              onFilesSelect={(files) =>
                addFiles(files, formik.values.documents, formik.setFieldValue)
              }
              onFileDelete={(file) =>
                removeFile(file, formik.values.documents, formik.setFieldValue)
              }
              acceptedFileTypes={[".pdf", ".doc", ".docx"]}
              error={formik.errors.documents}
              touched={formik.touched.documents}
              inputProps={{ id: "document-upload-input-assembly" }}
              title="Upload Documents"
              viewOnly={
                profile?.role !== userRoles.Quality_Controller_Inspector
              }
            />

            <Box mt={2}>
              <Typography variant="body1">Remarks</Typography>
              <TextField
                size="small"
                name="remarks"
                value={formik.values.remarks || ""}
                onChange={formik.handleChange}
                variant="outlined"
                sx={{ flex: 1, ...styles.textField }}
                error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                required
                fullWidth
                multiline
                rows={3}
                disabled={
                  profile?.role !== userRoles.Quality_Controller_Inspector
                }
              />
              {formik.touched.remarks && Boolean(formik.errors.remarks) && (
                <Typography variant="caption" color="error">
                  {formik.errors.remarks}
                </Typography>
              )}
            </Box>
            {profile?.role === userRoles.Quality_Controller_Inspector && (
              <Box sx={{ textAlign: "right" }} mt={2}>
                <AppButton
                  variant="contained"
                  color="primary"
                  label={isUpdating ? "Update" : "Submit"}
                  onClick={() => formik.handleSubmit()}
                  isLoading={formik.isSubmitting}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default NonDimentionalRFIDetails;
